import momentLocalTimezone from 'src/utils/momentLocalTimezone';

const makeInitialState = values => ({
  ...values,
  startDate: momentLocalTimezone(values.startDate),
  firstRentDate: momentLocalTimezone(values.firstRentDate),
  secondRentDate: momentLocalTimezone(values.firstRentDate).add(1, 'month'),
  endDate: momentLocalTimezone(values.endDate)
});

export default makeInitialState;
